import {Card} from "@material-ui/core";
import {CreateProps} from "react-admin";
import {CustomCreate} from "../components/CustomCreate";
import {EmployeeForm} from "./EmployeeForm";

export const EmployeeCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props} component={Card}>
      <EmployeeForm />
    </CustomCreate>
  );
};
